package com.milta.core.localization.translations.it

import com.milta.core.localization.SpreadsheetImportStrings

internal val SpreadsheetImport = SpreadsheetImportStrings(
    importFileTitle = "Importa un file",
    analysingTitle = "Analisi del file…",
    analysingSubtitle = "Stiamo identificando le colonne e rilevando le consegne presenti nel foglio.",
    fileSentSuffix = "appena inviato",
    structuredFormatBannerTitle = "Formato riconosciuto.",
    structuredFormatBannerMessage = "Le colonne sono state mappate automaticamente, nessuna correzione necessaria.",
    columnsInterpretedBannerTitle = "Colonne interpretate automaticamente.",
    columnsInterpretedBannerMessage = "Verifica le consegne segnalate prima di aggiungerle.",
    completePillLabel = "Tutto è completo",
    invalidFileTitle = "File non supportato.",
    invalidFileMessage = "Importa un file Excel (.xlsx) o CSV (.csv) valido.",
    chooseAnotherFileButton = "Scegli un altro file",
    extractionFailedTitle = "Impossibile leggere questo file.",
    extractionFailedMessage = "Il foglio sembra vuoto o la sua struttura non è stata riconosciuta — verifica il contenuto o inserisci le consegne manualmente.",
    retryWithNewFileButton = "Riprova con un altro file",
    serviceUnavailableTitle = "Servizio di analisi temporaneamente non disponibile.",
    serviceUnavailableMessage = "Riprova a breve, oppure completa questa consegna manualmente nel frattempo.",
)
